(function() {
  var ValidationEngine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ValidationEngine = App.loadClass('core::ValidationEngine');

  exports.Contracts_Handler = (function(superClass) {
    extend(Contracts_Handler, superClass);

    function Contracts_Handler() {
      return Contracts_Handler.__super__.constructor.apply(this, arguments);
    }

    Contracts_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/contracts/load-layout';
      this.layoutSelector = App.sidebar.contentDiv();
      this.singleSubHandler = false;
      this.filterParams = {};
      this.subHandlers = {
        'Add': {
          'class': 'portal::handlers/contracts/Contracts_Add_Handler'
        },
        'Edit': {
          'class': 'portal::handlers/contracts/Contracts_Edit_Handler'
        },
        'EditSelect': {
          'class': 'portal::handlers/contracts/Contracts_Edit_Select_Handler'
        },
        'ContractDialog': {
          'class': 'portal::handlers/contracts/Contracts_Contract_Dialog_Handler'
        }
      };
      this.loadLayout();
      return this.validator = new ValidationEngine();
    };

    Contracts_Handler.prototype.afterLoadLayout = function(selector, response) {
      var handler, ref, ths;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      ths = this;
      this.defaultSub = 'Add';
      handler = this.createSubHandler(this.defaultSub);
      if (handler) {
        handler.init();
      }
      this.dlg_handler = this.createSubHandler('ContractDialog');
      if (this.dlg_handler) {
        this.dlg_handler.init();
      }
      return $('a[data-toggle="tab"]').on('shown', (function(_this) {
        return function(e) {
          $('#span_total_acres').text('0.00');
          _this.destroyHandlers();
          _this.resetDialogSelects();
          if ($(e.target).html() === 'Edit') {
            _this.currMode = 'Edit';
            return _this.disableDialogForm();
          } else {
            _this.currMode = 'Add';
            return _this.enableDialogForm();
          }
        };
      })(this));
    };

    Contracts_Handler.prototype.destroyHandlers = function() {
      var handler, name, ref, results;
      ref = this.activeSubHandlers;
      results = [];
      for (name in ref) {
        handler = ref[name];
        if (name !== this.subHandlers['ContractDialog']["class"]) {
          results.push(handler.destroy());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    Contracts_Handler.prototype.resetDialogSelects = function() {
      this.dlg_handler.dialog.find('#sel_contracted_fields').html('');
      this.dlg_handler.dialog.find('#sel_fields').html('');
      return this.dlg_handler.dialog.find('#sel_grower').val('');
    };

    Contracts_Handler.prototype.unloadContract = function() {
      var handler;
      this.destroyHandlers();
      handler = this.createSubHandler('Edit');
      if (handler) {
        this.disableDialogForm();
        return handler.init();
      }
    };

    Contracts_Handler.prototype.loadContract = function(id) {
      var handler;
      this.destroyHandlers();
      handler = this.createSubHandler('EditSelect');
      if (handler) {
        this.enableDialogForm();
        handler.loadLayoutPostOptions = {
          id: id
        };
        return handler.init();
      }
    };

    Contracts_Handler.prototype.disableDialogForm = function() {
      return this.dlg_handler.disableForm();
    };

    Contracts_Handler.prototype.enableDialogForm = function() {
      return this.dlg_handler.enableForm();
    };

    Contracts_Handler.prototype.makeValidation = function(message) {
      this.validator.makeFormValidator('contracts_sidebar', '#form_contracts_add_edit', '#contracts_sidebar_errors', (function(_this) {
        return function(valid) {
          var handler;
          if (valid) {
            if (_this.dlg_handler.validator.validateForm('contracts_dialog')) {
              _this.unloadContract();
              _this.resetDialogSelects();
              handler = _this.createSubHandler('Add');
              if (handler) {
                return handler.init();
              }
            }
          }
        };
      })(this));
      this.validator.registerRule({
        'selector': '.validate-contract-number',
        'text': 'Contract number must be 8 digits in length',
        'func': function(elem) {
          var val;
          val = $(elem).val().replace(/\s-\s/g, '');
          return val.length === 8;
        }
      });
      return this.validator.registerRule({
        'selector': '.validate-sales-zone',
        'text': 'Please select a sales Zone',
        'func': function(elem) {
          var val;
          val = $(elem).val();
          return val > 0;
        }
      });
    };

    return Contracts_Handler;

  })(Handler);

}).call(this);
